module.exports = __webpack_public_path__ + "img/18Grant.264cc721.png";